import { AuthGuard, CrudOp, projectStructureAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const ProjectStructureView: FC = () => {
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  return (
    <AuthGuard authScope={projectStructureAuthScope} crudOp={CrudOp.READ} project={projectId}>
      <Suspense><LazyProjectStructureView projectId={projectId} subprojectId={subprojectId}/></Suspense>
    </AuthGuard>
  );
};

const LazyProjectStructureView = lazy(importView(
  () => import("../components/ProjectStructureView"),
  (it) => it.ProjectStructureView,
));
